import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router";

import { initializeApp } from "firebase/app";
import firebaseConfig from './Firebase/firebaseconfig';

import './css/custom.css';

import Login from './Pages/SignIn';
import Home from './Pages/Home';
import CheckForLogin from './Components/CheckForLogin';
import PasswordReset from './Pages/PasswordReset';
import Alunos from './Pages/Gerenciamento/Alunos';
import Empresas from './Pages/Gerenciamento/Empresas';
import Professores from './Pages/Gerenciamento/Professores';
import Usuarios from './Pages/Gerenciamento/Usuarios';
import { GlobalProvider } from './Components/GlobalContext';
import PoliticaPrivacidade from './Pages/PoliticaPrivacidade';
import TermosECondicoes from './Pages/TermosECondicoes';
import Presenca from './Pages/Gerenciamento/Presenca';
import ImpressaoPresenca from './Pages/Gerenciamento/ImpressaoPresenca';
import Presencas from './Pages/Relatorios/RelatorioPresencas';
import Configuracoes from './Pages/Configuracoes/Configuracoes';
import Dashboard from './Pages/Dashboard/Dashboard';
import Arquivos from './Pages/Arquivos/arquivos'

import UnattendedLogin from './Pages/UnattendedLogin';
import ManutencaoUsuarios from './Pages/Manutencao/ManutencaoUsuarios';

const app = initializeApp(firebaseConfig());

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <GlobalProvider>
    <BrowserRouter basename=''>
      <Routes>

        <Route index path="/" element={<CheckForLogin page={<Dashboard />} app={app} />} />
        <Route path="/login" element={<Login app={app} />} />
        <Route path="/external-login" element={<Login app={app} />} />

        <Route path="/trocar-senha" element={<PasswordReset app={app} />} />

        <Route path='/relatorios'>
          <Route path='presencas'>
            <Route index element={<CheckForLogin page={<Presencas />} app={app} />} />
            <Route path='detalhado' element={<ImpressaoPresenca />} />
          </Route>
        </Route>

        <Route path='/gerenciamento'>
          <Route
            path='usuarios'
            element={<CheckForLogin page={<Usuarios />} app={app} requiredRole={["admin"]} />}
          />
          <Route
            path='presenca'
            element={<CheckForLogin page={<Presenca />} app={app} requiredRole={["admin"]} />}
          />
          <Route
            path='alunos'
            element={<CheckForLogin page={<Alunos />} app={app} requiredRole={["admin"]} />}
          />
          <Route
            path='empresas'
            element={<CheckForLogin page={<Empresas />} app={app} requiredRole={["admin"]} />}
          />
          <Route
            path='professores'
            element={<CheckForLogin page={<Professores />} app={app} requiredRole={["admin"]} />}
          />
        </Route>

        <Route path='/manutencao'>
          <Route
            path='usuarios'
            element={<CheckForLogin page={<ManutencaoUsuarios />} app={app} requiredRole={["admin"]} />}
          />
        </Route>

        <Route
          path='/files'
          element={<CheckForLogin page={<Arquivos />} app={app} requiredRole={["admin", "externo"]} />}
        />

        <Route
          path='/configuracoes'
          element={<CheckForLogin page={<Configuracoes />} app={app} requiredRole={["admin"]} />}
        />

        <Route
          path='/dashboard'
          element={<CheckForLogin page={<Dashboard />} app={app} requiredRole={["admin", "externo"]} />}
        />

        <Route path='/impressao' element={<ImpressaoPresenca />} />

        <Route path="/privacidade" element={<PoliticaPrivacidade />} />
        <Route path="/termos-e-condicoes" element={<TermosECondicoes />} />

        <Route path="/ua/:uaCode" element={<UnattendedLogin />} app={app} />

      </Routes>
    </BrowserRouter>
  </GlobalProvider>
);
